import { Input, Icon, Row } from '@iqueue/ui-kit'
import { useState, useRef } from 'react'
import { GeolocateControl } from 'react-map-gl'
import { always } from 'ramda'
import GLMap from '../map/GLMap'

export default function PickLocation({ name, value, ...props }) {
  const iconRef = useRef()

  const [userLocation, setUserLocation] = useState(value || {
    lat: 41.3111519,
    lng: 69.2797104,
  })

  return <>
    <Row>
      <Input
        size={ 6 }
        name={ `${ name }.lat` }
        // placeholder={ 'Широта' }
        hidden
        value={ userLocation.lat }
        serialize={ Number.parseFloat }
        deserialize={ always(userLocation.lat) }
      />

      <Input
        size={ 6 }
        name={ `${ name }.lng` }
        // placeholder={ 'Долгота' }
        hidden
        value={ userLocation.lng }
        serialize={ Number.parseFloat }
        deserialize={ always(userLocation.lng) }
      />
    </Row>

    <div className={ 'pick-location-input-wrapper' }>
      <GLMap
        id={ "pickLocationMap" }
        initialViewState={ {
          latitude: userLocation.lat,
          longitude: userLocation.lng,
          zoom: 14,
        } }
        onGeolocate={ (e) => {
          setUserLocation({
            lat: +(e.coords.latitude.toFixed(6)),
            lng: +(e.coords.longitude.toFixed(6)),
          })
        } }
        onDragStart={ () => iconRef.current.classList.add('preview') }
        onDragEnd={ () => iconRef.current.classList.remove('preview') }
        onIdle={ (e) => {
          const center = e.target.getCenter()

          setUserLocation({
            lat: +(center.lat.toFixed(6)),
            lng: +(center.lng.toFixed(6)),
          })
        } }
      />

      <div ref={ iconRef } className={ 'cross' }>
        <Icon filled>fmd_good</Icon>
      </div>
    </div>
  </>
}
